import React from 'react';
import { Link } from 'react-router-dom';
import { Package } from 'lucide-react';
import { optimizedSrc } from '../../lib/image-cdn';

export const FamilyComponents = ({components = []}) => {
  if (!components.length) return null;
  return <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-8 border-t border-neutral-200" data-testid="family-components-section">
    <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
      <h2 className="text-base md:text-lg font-medium" data-testid="family-components-heading">Accessories &amp; components</h2>
      <Link to="/products/accessories" className="text-xs underline underline-offset-4" data-testid="family-all-components-link">All accessories ↗</Link>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-testid="family-components-grid">
      {components.map(item => <Link key={item.product_id} to={item.model_path} className="no-underline group min-w-0" data-testid={`family-component-${item.base_code.toLowerCase()}`}>
        <div className="aspect-[4/3] bg-white flex items-center justify-center mb-3">
          {item.primary_image ? <img data-testid={`family-component-image-${item.base_code.toLowerCase()}`} src={optimizedSrc(item.primary_image,{w:300})} alt={item.name} className="w-2/3 h-2/3 object-contain transition-opacity group-hover:opacity-80" loading="lazy" /> : <Package aria-hidden="true" className="w-7 h-7 text-neutral-400" />}
        </div>
        <p className="text-sm font-medium" data-testid={`family-component-code-${item.base_code.toLowerCase()}`}>{item.base_code}</p>
        <p className="text-xs text-neutral-600 mt-1 break-words" data-testid={`family-component-name-${item.base_code.toLowerCase()}`}>{item.name}</p>
      </Link>)}
    </div>
  </section>;
};